import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import {
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  Router,
  NavigationStart,
} from '@angular/router';
import { FirebaseService } from './services/firebase.service';
import { ThemeService } from './services/theme.service';
import { LoggerService } from './services/logger.service';
const version = require('./version.json');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private hideNav = true;
  error = '';
  appReady = false;

  // toggles loading spinner when navigating between routes
  loading = false;

  constructor(
    private authService: AuthService,
    private firebaseService: FirebaseService,
    // import logger service to ensure logging methods are overwritten
    private loggerService: LoggerService,
    private router: Router,
    private themeService: ThemeService
  ) {
    this.setupLoggingNavigationEvents();

    // used to ensure logger serivce is initialized, and remove unused warning
    this.loggerService;

    console.log('app.component -> constructor');
    // always log the version number
    console.log('version: ', version);
    this.themeService.initTheme();

    this.checkAuth();
    this.toggleNavOnRouteChange();
    this.showLoadingSpinnerOnNavigation();
    // initialize theme service
  }

  get showNav() {
    return /* this.authService.signedIn && */ !this.hideNav;
  }

  // Checks if the auth service is ready. The _appReady
  checkAuth() {
    this.authService.authReady.subscribe((authReady) => {
      console.log('app.component -> checkAuth -> authReady: ', authReady);
      this.appReady = authReady;
      if (this.appReady === false) {
        // there was an error starting the auth service
        this.firebaseService.logErrorEvent({
          error: 'auth_service_error',
        });
        this.error = 'Unexpected error encountered. Please try again later.';
      }
    });
  }

  showLoadingSpinnerOnNavigation() {
    this.router.events.subscribe((routerEvent) => {
      // console.log('router event: ', routerEvent);
      if (
        routerEvent instanceof NavigationEnd ||
        routerEvent instanceof NavigationCancel ||
        routerEvent instanceof NavigationError
      ) {
        this.loading = false;
      } else if (routerEvent instanceof NavigationStart) {
        this.loading = true;
      }
    });
  }

  toggleNavOnRouteChange() {
    this.router.events.subscribe((routerEvent) => {
      if (routerEvent instanceof NavigationEnd) {
        if (
          routerEvent.url.startsWith('/login') ||
          routerEvent.url.startsWith('/sign-up') ||
          routerEvent.url.startsWith('/register') ||
          routerEvent.url.startsWith('/manage-auth') ||
          routerEvent.url.startsWith('/terms-and-conditions')
          // || routerEvent.url.startsWith('/privacy-policy')
        ) {
          this.hideNav = true;
        } else {
          this.hideNav = false;
        }
      }
    });
  }

  setupLoggingNavigationEvents() {
    this.router.events.subscribe((routerEvent) => {
      if (routerEvent instanceof NavigationEnd) {
        const path = routerEvent.urlAfterRedirects || routerEvent.url;
        console.log('[navigation event] -', path);
      }
    });
  }
}
